import { styled } from '@uhg-abyss/web/tools/styled';
export const ProgressBarContainer = styled('div', {
  width: '100%',
  height: '14px',
  overflow: 'hidden',
  border: '2px solid #929496',
  borderRadius: '3px',
});
export const ProgressBarFill = styled('div', {
  static: {
    height: '20px',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },
  dynamic: ({ cssProps }) => {
    const { progress, fillColor } = cssProps;
    return {
      width: `${progress || 0}%`,
      backgroundColor: fillColor || '$core.color.yellow.100',
    };
  },
});
